import * as A from "fp-ts/Array";
import { flow, pipe } from "fp-ts/function";
import { getChildNodes, toDocumentFragment } from "./parse5-utils";
const applyRootRule = (rule) => (node) => {
  const [_if, then] = rule;
  return _if(node) ? then(node) : node;
};
const applyRule = (rule) => (node) => {
  const [_if, then] = rule;
  const processed = _if(node) ? then(node) : node;
  return {
    ...processed,
    childNodes: visit(rule)(processed)
  };
};
const visit = (rule) => (element) => (
  // @ts-ignore $TSFixMe
  pipe(element, getChildNodes, A.map(applyRule(rule)))
);
const traverse = (rule) => flow(visit(rule), toDocumentFragment);
const traverseRoot = (rule) => (root) => pipe(root, applyRootRule(rule));
export {
  traverse,
  traverseRoot
};
//# sourceMappingURL=ast-traversal.js.map
